



















import { Vue, Component, Prop } from "vue-property-decorator";
import EventModel from "@/models/event/eventModel";
import UserModel from "@/models/user/userModel";

@Component
export default class Clash extends Vue {
  @Prop(Object) readonly event!: EventModel;
  @Prop(Array) readonly users!: Array<UserModel>;

  private userName(id: string): string {
    const user = this.users.find(x => x.userId == id);
    return user ? user.fullname : "";
  }
}
